export enum AccessControlQueryKeys {
  MY_ACCESS = 'access-control-my-access',
}
